var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0653 11.9377L20.3753 4.66167C20.4887 4.52567 20.534 4.367 20.5113 4.18567C20.5113 4.00433 20.4433 3.84567 20.3073 3.70967C20.194 3.57367 20.0467 3.50567 19.8653 3.50567C19.684 3.483 19.5253 3.52833 19.3893 3.64167L12.0793 10.9517L4.80334 3.64167C4.66734 3.52833 4.50868 3.483 4.32734 3.50567C4.14601 3.50567 3.98734 3.57367 3.85134 3.70967C3.71534 3.823 3.636 3.97033 3.61334 4.15167C3.61334 4.333 3.67 4.49167 3.78334 4.62767L11.0933 11.9377L3.78334 19.2137C3.55667 19.395 3.466 19.633 3.51133 19.9277C3.57933 20.2223 3.76067 20.4037 4.05534 20.4717C4.35001 20.5397 4.58801 20.4603 4.76934 20.2337L12.0793 12.9237L19.3553 20.2337C19.4913 20.347 19.65 20.4037 19.8313 20.4037C20.0127 20.381 20.1713 20.313 20.3073 20.1997C20.4433 20.0637 20.5113 19.905 20.5113 19.7237C20.534 19.5423 20.4887 19.3837 20.3753 19.2477L13.0653 11.9377Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.bb056ad6e3bc2ff613b0a6858a46fe81.svg";
export { ForwardRef as ReactComponent };